import { EntityAction, createConfirmDialog } from 'components';
import type { Expense } from './types';

export const actions: EntityAction<Expense>[] = [
  {
    action: 'confirm',
    button: {
      children: 'Confirm',
      icon: 'check',
      variant: 'secondary-success',
    },
    visible: ({ state }) => state === 'DRAFT',
  },
  {
    action: 'draft',
    button: {
      children: 'Draft',
      icon: 'ban',
      variant: 'secondary',
    },
    requestDialog: createConfirmDialog(),
    visible: ({ state }) => state === 'CANCELED',
  },
  {
    action: 'cancel',
    button: {
      children: 'Cancel',
      icon: 'ban',
      variant: 'secondary-danger',
    },
    requestDialog: createConfirmDialog(),
    visible: ({ can_cancel }) => can_cancel,
  },
  {
    action: 'mark_linked',
    button: {
      children: 'Mark linked',
      variant: 'secondary-success',
      icon: 'link',
    },
    visible: ({ state, type, linked_at }) => state === 'CONFIRMED' && type === 'INVOICE' && !linked_at,
  },
  {
    action: 'mark_not_linked',
    button: {
      children: 'Mark not linked',
      variant: 'secondary-danger',
      icon: 'link-slash',
    },
    visible: ({ state, type, linked_at }) => state === 'CONFIRMED' && type === 'INVOICE' && !!linked_at,
  },
];

export const bookingActions: EntityAction<Expense>[] = [
  {
    action: 'book_create',
    permKey: 'book_expense',
    button: {
      children: 'Create',
      icon: 'book-open',
      variant: 'secondary',
      size: 'sm',
    },
    visible: ({ state, booking_state }) => state !== 'CANCELED' && booking_state === 'NONE',
  },
  {
    action: 'book_sync',
    permKey: 'book_expense',
    button: {
      children: 'Sync',
      icon: 'book-open',
      size: 'sm',
      variant: 'secondary',
    },
    visible: ({ state, booking_state }) => state !== 'CANCELED' && booking_state !== 'NONE',
  },
];
